import React from 'react'
import PricingSurvey from 'sprockets_react/components/business/PricingSurvey'

class EditPricing extends PricingSurvey {
  constructor(props) {
    super(props)

    this.state = {
      formData: {
        gst_included: props.gst_included !== null ? props.gst_included : true,
        price: props.price ? parseFloat(props.price).toFixed(2) : '',
        unit: props.unit || '',
        pricing_survey_answered: ''
      },
      deleting: false,
      deleted: false,
      errorMessage: '',
      submitting: false,
      submitted: false,
      successMessage: ''
    }

    this.handleDelete = this.handleDelete.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.resetForm = this.resetForm.bind(this)
    this.resetSubmitted = this.resetSubmitted.bind(this)
  }

  resetSubmitted() {
    this.setState({ submitted: false })
  }

  resetForm() {
    const initialFormData = {
      gst_included: true,
      price: '',
      unit: '',
      pricing_survey_answered: ''
    }

    this.setState({
      formData: initialFormData,
      submitted: false
    })
  }

  handleDelete(event) {
    event.preventDefault()

    const confirmDelete = window.confirm('Are you sure you want to delete?')

    if (confirmDelete) {

      let businessPricingDelete = SS.API.V3.businessPricingDelete()

      businessPricingDelete.beforeSend = () => {
        this.setState({ deleting: true })
      }

      $.ajax(businessPricingDelete)
        .done((response) => {
          this.setState({
            errorMessage: '',
            deleted: true,
            deleting: false,
            successMessage: response.message })

          this.resetForm()
        })
        .fail((error) => {
          this.setState({
            errorMessage: error.responseJSON.error_message,
            deleted: false,
            deleting: false,
          })
        })
    }
  }

  handleSubmit(event) {
    event.preventDefault()

    const { formData } = this.state

    var businessPricingCreate = SS.API.V3.businessPricingCreate(formData)

    businessPricingCreate.beforeSend = () => {
      this.setState({ submitting: true })
    }

    $.ajax(businessPricingCreate)
      .done((response) => {
        this.hidePricingSurveyAlert()
        this.setState({
          errorMessage: '',
          submitted: true,
          submitting: false,
          successMessage: `Your standard price of $${formData.price} per ${this.getUnitLabel()} has been set. We show pricing on your Business Profile and use it to analyse pricing in your industry.`
        })
      })
      .fail((error) => {
        this.setState({
          errorMessage: error.responseJSON.error_message,
          submitted: false,
          submitting: false,
        })
      })
  }

  renderSuccessMessage() {
    const { successMessage } = this.state

    return (
      <div className='alert alert-success alert-dismissible' role='alert'>
        <button type='button' className='close' data-dismiss='alert' aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
        <span className='font-20 bold'>
          {successMessage}
        </span>
      </div>
    )
  }

  renderErrorMessage() {
    const { errorMessage } = this.state

    return (
      <div className='alert alert-danger alert-dismissible' role='alert'>
        <button type='button' className='close' data-dismiss='alert' aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
        <span className='font-20 bold'>{errorMessage}</span>
      </div>
    )
  }

  render() {
    const { deleting, deleted, errorMessage, formData, submitted, submitting } = this.state
    const isInvalid = formData.unit === '' || formData.price === ''
    const saveButtonText = submitting ? 'Saving...' : 'Save'
    const deleteButtonText = deleting ? 'Deleting...' : 'Delete'

    return(
      <div>
        {(submitted || deleted) && this.renderSuccessMessage()}
        {this.state.errorMessage !== '' && this.renderErrorMessage()}
        <form className='pricing-form' onSubmit={this.handleSubmit}>
          <div className='form-group row'>
            <div className='col-xs-12'>
              <h1 className='bold fs17 mb20'>How do you set your rates?</h1>
              <div>
                <input type='radio' id='unit_hourly' name='unit' value='hourly' checked={formData.unit === 'hourly' ? 'checked' : ''} onChange={(e) => { this.handleChange(e); this.resetSubmitted(); }} />
                <span className='fs15 text-300 ml5'>Hourly</span>
              </div>
              <div>
                <input type='radio' id='unit_daily' name='unit' value='daily' checked={formData.unit === 'daily' ? 'checked' : ''} onChange={(e) => { this.handleChange(e); this.resetSubmitted(); }} />
                <span className='fs15 text-300 ml5'>Daily</span>
              </div>
              <div>
                <input type='radio' id='unit_lineal_rate' name='unit' value='lineal_rate' checked={formData.unit === 'lineal_rate' ? 'checked' : ''} onChange={(e) => { this.handleChange(e); this.resetSubmitted(); }} />
                <span className='fs15 text-300 ml5'>Per Lineal Rate</span>
              </div>
              <div>
                <input type='radio' id='unit_square_metre' name='unit' value='square_metre' checked={formData.unit === 'square_metre' ? 'checked' : ''} onChange={(e) => { this.handleChange(e); this.resetSubmitted(); }} />
                <span className='fs15 text-300 ml5'>Per Square Metre</span>
              </div>
              <div>
                <input type='radio' id='unit_cubic_metre' name='unit' value='cubic_metre' checked={formData.unit === 'cubic_metre' ? 'checked' : ''} onChange={(e) => { this.handleChange(e); this.resetSubmitted(); }} />
                <span className='fs15 text-300 ml5'>Per Cubic Metre</span>
              </div>
            </div>
          </div>
          <div className='row form-group'>
            <div className='col-xs-12'>
              <h1 className='bold fs17 mb20'>Specify your minimum price</h1>
              <div className='row'>
                <div className='col-xs-2 col-sm-1 text-300 fs15 text-light-gray vcenter'>From</div>
                <div className='col-xs-4 col-sm-3 vcenter mr0 pr0'>
                  <div className='input-group border-blue mb8'>
                    <div className='input-group-addon bg-white pr0 no-border'>
                      <i className='ficon-dollar text-300 fs15'></i>
                    </div>
                    <input
                      className='form-control text-300 fs15 no-border price-survey-input'
                      name='price'
                      onChange={(e) => { this.handleChange(e); this.resetSubmitted(); }}
                      type='number'
                      value={formData.price}
                    />
                  </div>
                </div>
                {
                  formData.unit !== '' &&
                  <div className='col-xs-6 col-sm-8 vcenter fs15 text-300'>
                    / {this.getUnitLabel()}
                  </div>
                }
              </div>
            </div>
          </div>
          <div className='row form-group'>
            <div className='col-xs-12'>
              <input type='radio' id='gst_included_yes' name='gst_included' value={true} checked={formData.gst_included ? 'checked' : ''} onChange={(e) => { this.handleChange(e); this.resetSubmitted(); }} />
              <span className='fs15 text-300 ml5'>Inc. GST</span>
              <input type='radio' id='gst_included_no' name='gst_included' value={false} checked={!formData.gst_included ? 'checked' : ''} onChange={(e) => { this.handleChange(e); this.resetSubmitted(); }} className='ml20' />
              <span className='fs15 text-300 ml5'>Ex.GST</span>
            </div>
          </div>
          <div className='row form-group mt20'>
            <div className='col-xs-6 col-sm-4'>
              <input type='submit'
                     name='commit'
                     value={saveButtonText}
                     className='btn btn-secondary radius-6 text-300 font-20 btn-block'
                     disabled={(submitted && !isInvalid) || submitting || isInvalid}
              />
            </div>
            {
              ((!deleted && this.props.price !== null) || (submitted && formData.price !== '')) &&
              <div className='col-xs-6 col-sm-4'>
                <button onClick={this.handleDelete} className='btn btn-secondary radius-6 text-300 font-20 btn-block' disabled={deleting}>{deleteButtonText}</button>
              </div>
            }
          </div>
        </form>
      </div>
    )
  }
}

export default EditPricing
